import { render } from "./ApNumberBlock.vue?vue&type=template&id=140ceb9a&scoped=true&ts=true"
import script from "./ApNumberBlock.vue?vue&type=script&lang=ts"
export * from "./ApNumberBlock.vue?vue&type=script&lang=ts"

import "./ApNumberBlock.vue?vue&type=style&index=0&id=140ceb9a&scoped=true&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140ceb9a"]])

export default __exports__